module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "redRain"
    }
  }, [_vm._l((_vm.rainlist), function(n, index) {
    return _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index > _vm.rainIndex),
        expression: "index > rainIndex"
      }],
      key: index,
      staticClass: "rainImg",
      style: (n),
      attrs: {
        "src": _vm.imgPath + 'home/redbagrain.png'
      },
      on: {
        "click": _vm.getRainRed
      }
    })
  }), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.redrain1),
      callback: function($$v) {
        _vm.redrain1 = $$v
      },
      expression: "redrain1"
    }
  }, [_c('div', {
    attrs: {
      "id": "redrainfails"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/redrainno.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v("空空如也，再接再厉")])]), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'close.png'
    },
    on: {
      "click": _vm.redrain1OO
    }
  })]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.redrain2),
      callback: function($$v) {
        _vm.redrain2 = $$v
      },
      expression: "redrain2"
    }
  }, [_c('div', {
    attrs: {
      "id": "redrainSuccess"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("恭喜您，成功抢到")]), _vm._v(" "), _c('p', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm.rainmoney / 100)), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "mannum"
  }, [_c('span', [_vm._v(_vm._s(_vm.mannum))]), _vm._v("人已抢到。")]), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'close.png'
    },
    on: {
      "click": _vm.redrain2OO
    }
  })])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb47e720"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/redRain.vue
// module id = 352
// module chunks = 0